import styled from 'styled-components';

import theme from './theme';

export const Container = styled.div`
  background-color: ${theme.backgroundColor};
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
`;

export const LoadingTitle = styled.h2`
  min-height: 8rem;
  text-align: center;
  font-family: ${Styles.fontFamily.base};
  color: ${theme.titleColor};
  font-weight: bold;
  font-size: 1.625rem;
  letter-spacing: -0.7px;
  margin: 0 auto;
  padding: 0rem 2.5rem;
`;

export const LoadingText = styled.p`
  text-align: center;
  font-size: 0.9375rem;
  line-height: 1.33;
  color: ${theme.textColor};
  font-family: ${Styles.fontFamily.body};
  padding: 0rem 3.5rem;
`;
